'use client';

import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Button } from "../../atoms/Button/Button.js";
import { DotsThreeVertical } from "../../../react-icons.js";
function ActionMenuTriggerComponent({ children, ...rest }, ref) {
  return /* @__PURE__ */ jsx(Button, { ...rest, icon: DotsThreeVertical, ref, hiddenLabel: true, children });
}
const ActionMenuTrigger = forwardRef(ActionMenuTriggerComponent);
export {
  ActionMenuTrigger
};
